import { IColumnDefinition } from 'features/Lists/core/contracts/IColumnDefinition'

export enum BreakSummaryStatusEnum {
  InProgress = 'InProgress',
  New = 'New',
  Suppressed = 'Suppressed',
  PermanentlySuppressed = 'PermanentlySuppressed',
  Resolved = 'Resolved'
}

enum ColumnIdsEnum {
  id = 'id',
  legalEntityName = 'legalEntityName',
  accountNo = 'accountNo',
  securityDesc = 'securityDesc',
  cusip = 'cusip',
  accountId = 'accountId',
  breakDesc = 'breakDesc',
  lastupdatedBy = 'lastupdatedBy',
  lastupdatedDate = 'lastupdatedDate',
  comments = 'comments',
  breakDetailId = 'breakDetailId',
  breakStatus = 'breakStatus',
  reconSystemCode = 'reconSystemCode',
  advisorName = 'advisorName',
  householdName = 'householdName',
  l1Description = 'l1Description',
  l2Description = 'l2Description',
  l3Description = 'l3Description',
  l4Description = 'l4Description',
  assetType = 'assetType',
  assetSubType = 'assetSubType'
}

export const BreakDetailColumnIds = { ...ColumnIdsEnum }
export type BreakDetailColumnIds = typeof BreakDetailColumnIds

export const BreakDetailColumnDefinitions: Record<string, IColumnDefinition> = {
  [BreakDetailColumnIds.id]: {
    id: BreakDetailColumnIds.id,
    name: ' ',
    type: 'string',
    width: 30,
    filterable: false,
    sortable: false,
    searchable: false,
    facetable: false,
    dataPath: 'id',
    selectable: false
  },
  [BreakDetailColumnIds.legalEntityName]: {
    id: BreakDetailColumnIds.legalEntityName,
    name: 'Legal entity name',
    type: 'string',
    width: 180,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: false,
    dataPath: 'legalEntityName',
    selectable: false
  },
  [BreakDetailColumnIds.accountNo]: {
    id: BreakDetailColumnIds.accountNo,
    name: 'Account number',
    type: 'string',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: false,
    dataPath: 'accountNo',
    selectable: false
  },
  [BreakDetailColumnIds.securityDesc]: {
    id: BreakDetailColumnIds.securityDesc,
    name: 'Description',
    type: 'string',
    width: 280,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'securityDesc',
    selectable: false
  },
  [BreakDetailColumnIds.cusip]: {
    id: BreakDetailColumnIds.cusip,
    name: 'CUSIP',
    type: 'string',
    width: 120,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: false,
    dataPath: 'cusip',
    selectable: false
  },
  [BreakDetailColumnIds.accountId]: {
    id: BreakDetailColumnIds.accountId,
    name: 'Action',
    type: 'string',
    width: 180,
    filterable: false,
    sortable: false,
    searchable: false,
    facetable: false,
    dataPath: 'accountId',
    selectable: false
  },

  [BreakDetailColumnIds.breakDesc]: {
    id: BreakDetailColumnIds.breakDesc,
    name: 'Break description',
    type: 'string',
    width: 420,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: false,
    dataPath: 'breakDesc'
  },
  [BreakDetailColumnIds.householdName]: {
    id: BreakDetailColumnIds.householdName,
    name: 'Household Name',
    type: 'string',
    width: 200,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: false,
    dataPath: 'householdName'
  },
  [BreakDetailColumnIds.advisorName]: {
    id: BreakDetailColumnIds.advisorName,
    name: 'Advisor Name',
    type: 'string',
    width: 200,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: false,
    dataPath: 'advisorName'
  },
  [BreakDetailColumnIds.lastupdatedBy]: {
    id: BreakDetailColumnIds.lastupdatedBy,
    name: 'Suppressed By',
    type: 'string',
    width: 180,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'lastupdatedBy'
  },
  [BreakDetailColumnIds.lastupdatedDate]: {
    id: BreakDetailColumnIds.lastupdatedDate,
    name: 'Date/ time',
    type: 'date',
    width: 180,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'lastupdatedDate',
    className: 'align-left'
  },
  [BreakDetailColumnIds.comments]: {
    id: BreakDetailColumnIds.comments,
    name: 'Comments',
    type: 'string',
    width: 110,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'comments'
  },
  [BreakDetailColumnIds.breakDetailId]: {
    id: BreakDetailColumnIds.breakDetailId,
    name: 'Break Detail ID',
    type: 'string',
    width: 160,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'breakDetailId'
  },
  [BreakDetailColumnIds.breakStatus]: {
    id: BreakDetailColumnIds.breakStatus,
    name: 'Break Status',
    type: 'string',
    width: 110,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'breakStatus',
    selectable: false,
    hidden: true
  },
  [BreakDetailColumnIds.reconSystemCode]: {
    id: BreakDetailColumnIds.reconSystemCode,
    name: 'Recon System Code',
    type: 'string',
    width: 110,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'reconSystemCode',
    selectable: false,
    hidden: true
  },
  [BreakDetailColumnIds.l1Description]: {
    id: BreakDetailColumnIds.l1Description,
    name: 'L1 Description',
    type: 'string',
    width: 110,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'l1Description',
    selectable: false,
    hidden: true
  },
  [BreakDetailColumnIds.l2Description]: {
    id: BreakDetailColumnIds.l2Description,
    name: 'L2 Description',
    type: 'string',
    width: 110,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'l2Description',
    selectable: false,
    hidden: true
  },
  [BreakDetailColumnIds.l3Description]: {
    id: BreakDetailColumnIds.l3Description,
    name: 'L3 Description',
    type: 'string',
    width: 110,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'l3Description',
    selectable: false,
    hidden: true
  },
  [BreakDetailColumnIds.l4Description]: {
    id: BreakDetailColumnIds.l4Description,
    name: 'L4 Description',
    type: 'string',
    width: 110,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'l4Description',
    selectable: false,
    hidden: true
  },
  [BreakDetailColumnIds.assetType]: {
    id: BreakDetailColumnIds.assetType,
    name: 'Asset Type',
    type: 'string',
    width: 110,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'assetType',
    selectable: false,
    hidden: true
  },
  [BreakDetailColumnIds.assetSubType]: {
    id: BreakDetailColumnIds.assetSubType,
    name: 'Asset Sub Type',
    type: 'string',
    width: 110,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'assetSubType',
    selectable: false,
    hidden: true
  }
}

export const BreakDetailDefaultColumns: ColumnIdsEnum[] = [
  ColumnIdsEnum.id,
  ColumnIdsEnum.legalEntityName,
  ColumnIdsEnum.accountNo,
  ColumnIdsEnum.securityDesc,
  ColumnIdsEnum.cusip,
  ColumnIdsEnum.accountId,
  ColumnIdsEnum.breakDesc,
  ColumnIdsEnum.advisorName,
  ColumnIdsEnum.householdName,
  ColumnIdsEnum.lastupdatedBy,
  ColumnIdsEnum.lastupdatedDate,
  ColumnIdsEnum.comments,
  ColumnIdsEnum.breakDetailId,
  ColumnIdsEnum.l1Description,
  ColumnIdsEnum.l2Description,
  ColumnIdsEnum.l3Description,
  ColumnIdsEnum.l4Description,
  ColumnIdsEnum.assetType,
  ColumnIdsEnum.assetSubType
]
